var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTowerConnectivityInternet5G(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 18.8435C1.45 18.8435 0.979167 18.6477 0.5875 18.256C0.195833 17.8643 0 17.3935 0 16.8435V2.84351C0 2.29351 0.195833 1.82267 0.5875 1.43101C0.979167 1.03934 1.45 0.843506 2 0.843506H20C20.55 0.843506 21.0208 1.03934 21.4125 1.43101C21.8042 1.82267 22 2.29351 22 2.84351V16.8435C22 17.3935 21.8042 17.8643 21.4125 18.256C21.0208 18.6477 20.55 18.8435 20 18.8435H2ZM2 16.8435H20V2.84351H2V16.8435ZM18 8.84351H15V10.8435H16V12.8435H13V6.84351H18C18 6.29351 17.8042 5.82267 17.4125 5.43101C17.0208 5.03934 16.55 4.84351 16 4.84351H13C12.45 4.84351 11.9792 5.03934 11.5875 5.43101C11.1958 5.82267 11 6.29351 11 6.84351V12.8435C11 13.3935 11.1958 13.8643 11.5875 14.256C11.9792 14.6477 12.45 14.8435 13 14.8435H16C16.55 14.8435 17.0208 14.6477 17.4125 14.256C17.8042 13.8643 18 13.3935 18 12.8435V8.84351ZM4 14.8435H8C8.55 14.8435 9.02083 14.6477 9.4125 14.256C9.80417 13.8643 10 13.3935 10 12.8435V10.8435C10 10.2935 9.80417 9.82267 9.4125 9.43101C9.02083 9.03934 8.55 8.84351 8 8.84351H6V6.84351H10V4.84351H4V10.8435H8V12.8435H4V14.8435Z",
    fill: "#FF0953"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTowerConnectivityInternet5G);
export default __webpack_public_path__ + "static/media/tower_connectivity_internet_5g.43c930484eac15491c5007a5d88a0196.svg";
export { ForwardRef as ReactComponent };